
export const allowedChar = [
    'А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф',
    'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ы', 'Ь', 'Э', 'Ю', 'Я', 'Ў', 'Қ', 'Ғ', 'Ҳ', '㎪', '㎏', '≤', '≠', '√', 'Ⅰ', 'Ⅱ',
    'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ', 'Ⅺ', 'Ⅻ', '[', '+', '-', '=', '<', '>', '_', '\'', '~', ']', 'а',
    'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц',
    'ч', 'ш', 'щ', 'ъ', 'ы', 'ь', 'э', 'ю', 'я', 'ў', 'қ', 'ғ', 'ҳ', '㎞', '㎡', '≥', '?', '∞', 'ⅰ', 'ⅱ', 'ⅲ', 'ⅳ',
    'ⅴ', 'ⅵ', 'ⅶ', 'ⅷ', 'ⅸ', 'ⅹ', 'ⅺ', 'ⅻ', '}', '"', '№', ';', ',', ':', '/', '\\', '|', '{', 'A', 'B', 'C', 'D',
    'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Ö',
    'Ç', 'Ğ', 'Ş', 'Ü', 'Ŋ', 'Ӑ', 'Ѐ', 'Ӗ', 'Ṓ', '㎇', '㎾', '⌛️', '⊕', '≡', '∫', '∆', 'ℼ', '™', '℃', '฿', '§', '½',
    '÷', '·', '±', '®', '«', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g',
    'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'ö', 'ç', 'ğ', 'ş',
    'ü', 'ŋ', 'ӑ', 'ѐ', 'ӗ', 'ṓ', '㎖', '㎥', ' ', '⊗', '≢', '≈', '∅', '⅀', '℠', '℉', '€', '¤', '¾', '¼', '×', '¶', '©',
    '»', ')', '!', '@', '#', '$', '%', '^', '&', '*', '('
]

//     export const checkForbiddenChar = (value: string): string[] =>{
//     const res: Set<string> = new Set()
//         for(let char of value){
//           if  (allowedChar.indexOf(char) === -1 ) {res.add(char)}
//         }
//     return Array.from(res)
// }


//return true if name consists not only prohibited char and vis validation turn On in env
export const checkForbiddenChar = (value: string): boolean =>{
    return   process.env.REACT_APP_PRODUCT_NAME_FORBIDDEN_CHAR_VALIDATION==='true'?
        value.split("").reduce((acc, curr)=>{
            return allowedChar.indexOf(curr)>=0 ? acc+curr : acc
        },"").trim().length >0
        : true
}


export const psidValidationEnv= !!process.env.REACT_APP_PSID_VALIDATION ?  process.env.REACT_APP_PSID_VALIDATION === 'true' : true


